"use client";

import React from "react";
import { Shield, FileText, Scale, Users, BookOpen, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ResponsabilitaEnti231() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    id: "item-1",
    title: "Risk Assessment & Mappatura",
    icon: <Shield className="w-5 h-5 text-ring" />,
    content: "Analisi approfondita dei processi aziendali per identificare le aree a rischio di reato. Valutiamo l'esposizione dell'ente e definiamo le priorità di intervento per garantire una protezione efficace e mirata."
  }, {
    id: "item-2",
    title: "Codice Etico e Comportamentale",
    icon: <FileText className="w-5 h-5 text-ring" />,
    content: "Redazione e aggiornamento del Codice Etico, documento fondamentale che definisce i valori, i principi e le norme di comportamento a cui devono attenersi tutti i soggetti che operano per conto dell'azienda."
  }, {
    id: "item-3",
    title: "Modello Organizzativo (MOGC)",
    icon: <Scale className="w-5 h-5 text-ring" />,
    content: "Progettazione e implementazione di Modelli di Organizzazione, Gestione e Controllo su misura (ex D.Lgs. 231/01), completi di protocolli decisionali e procedure operative per prevenire la commissione di reati."
  }, {
    id: "item-4",
    title: "Organismo di Vigilanza (OdV)",
    icon: <Users className="w-5 h-5 text-ring" />,
    content: "Supporto nella nomina e nelle attività dell'Organismo di Vigilanza. Offriamo professionisti qualificati per ricoprire il ruolo o assistiamo l'OdV interno nelle attività di audit e verifica periodica."
  }, {
    id: "item-5",
    title: "Formazione e Diffusione",
    icon: <BookOpen className="w-5 h-5 text-ring" />,
    content: "Piani di formazione personalizzati per dipendenti, dirigenti e collaboratori. La consapevolezza diffusa è il primo presidio di legalità e riduce drasticamente il rischio di comportamenti non conformi."
  }];
  return;
}